import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { useFilters } from '@elfsight/widget-filters';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { useLocationsFilter } from '../../locations-filter-provider';
import { useAvailableFilters } from '../../utils/use-available-filters';
import { ClearButton } from './clear-button';
import { filterControls } from './controls';
import { PaneFilter } from './pane-filter';

export function Filters() {
  const { backgroundColor } = useSettings();
  const { filtersAppliedCount } = useFilters();
  const { availableFilters } = useAvailableFilters();
  const { currentFiltersStyle } = useLocationsFilter();

  if (!availableFilters.length) {
    return null;
  }

  if (currentFiltersStyle === 'inline') {
    return (
      <Container>
        <Wrapper>
          {availableFilters.map(({ type }) => {
            const Component = filterControls[type];
            return <Component key={type} setting={type} type="inline" />;
          })}

          <Show when={!!filtersAppliedCount}>
            <StyledClearButton _background={backgroundColor} />
          </Show>
        </Wrapper>
      </Container>
    );
  }

  return (
    <Wrapper>
      <PaneFilter />
      <Show when={!!filtersAppliedCount}>
        <ClearButton />
      </Show>
    </Wrapper>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'filters',
    element: 'container'
  })
})`
  position: absolute;
  z-index: 9999999990;
  top: 24px;
  left: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

const Wrapper = styled.div.attrs({
  className: createReadableClass({
    component: 'filters',
    element: 'wrapper'
  })
})`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const StyledClearButton = styled(ClearButton)<{ _background: string }>`
  border-radius: 8px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
  background-color: ${({ _background }) => _background} !important;
`;
